import { createTrackerOptions } from '@/helpers/common';

export const MOBILE_RESULTS_BREAKPOINT = 1060;
export const RESULTS_SIDEBAR_BREAKPOINT = 1400;

export const INSURER_MIN_AGE = 16;

export const OPTIONAL_EXTRAS_OPTIONS = [
  {
    value: 'theft',
    trackerValue: 'theft',
    label: 'Theft',
  },
  {
    value: 'publicLiability',
    trackerValue: 'publicLiability',
    label: 'Public liability',
  },
  {
    value: 'accident',
    trackerValue: 'personalAccident',
    label: 'Personal accident',
  },
  {
    value: 'legal',
    trackerValue: 'legalCover',
    label: 'Legal cover',
  },
  {
    value: 'accesories',
    trackerValue: 'accessoryCover',
    label: 'Accessory cover',
    infoLabel: 'Accessories',
  },
  {
    value: 'travel',
    trackerValue: 'travel',
    label: 'Travel',
  },
];

export const OPTIONAL_EXTRAS_TRACKER_OPTIONS = createTrackerOptions(OPTIONAL_EXTRAS_OPTIONS);

export const POLICY_TYPE_OPTIONS = [
  {
    value: 'Monthly Policy - Fixed price',
    trackerValue: 'Fixed price',
    label: 'Monthly Policy - Fixed price',
  },
  {
    value: 'Monthly Policy - Variable price',
    trackerValue: 'Variable price',
    label: 'Monthly Policy - Variable price',
  },
];

export const POLICY_TYPE_TRACKER_OPTIONS = createTrackerOptions(POLICY_TYPE_OPTIONS);

export const MAXIMUM_EXCESS_OPTIONS = [
  {
    text: 'Any Excess',
    trackerValue: 'Any Excess',
    value: 'any',
  },
  {
    text: 'No Excess',
    trackerValue: 'No Excess',
    value: 0,
  },
  {
    text: 'Up to £50',
    trackerValue: 'Up to £50',
    value: 50,
  },
  {
    text: 'Up to £100',
    trackerValue: 'Up to £100',
    value: 100,
  },
  {
    text: 'Up to £150',
    trackerValue: 'Up to £150',
    value: 150,
  },
  {
    text: 'Up to £200',
    trackerValue: 'Up to £200',
    value: 200,
  },
  {
    text: 'Up to £250',
    trackerValue: 'Up to £250',
    value: 250,
  },
  {
    text: 'Up to £300',
    trackerValue: 'Up to £300',
    value: 300,
  },
  {
    text: 'Up to £350',
    trackerValue: 'Up to £350',
    value: 350,
  },
  {
    text: 'Up to £400',
    trackerValue: 'Up to £400',
    value: 400,
  },
];

export const COVER_BOOST_EXTRAS_ORDER_BY_NAME = [
  'theft',
  'publicLiability',
  'accident',
  'legal',
  'accesories',
  'travel',
];

export const OPTIONAL_EXTRA_COVER_MAX = 1000000;
